import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import UpProperty from '../../../../../components/Table/UpProperty';
import UpVehicleTable from '../../../../../components/Table/UpVehicle';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import {Itabs} from '../../../../../interface/Tab';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

const Upstream: React.FC<{
  selectedYear: string;
  planPropertyKey: accessModule;
  planVehicleKey: accessModule;
}> = ({selectedYear, planPropertyKey, planVehicleKey}) => {
  const UPSTab: Itabs[] = [
    {
      id: `property_${planPropertyKey}`,
      name: <TranslatedText translationKey="Property" />,
      component: shouldBlockModuleAccess(planPropertyKey) ? (
        <BlockAccessPage />
      ) : (
        <UpProperty selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerUpstreamProperty)
    },
    {
      id: `vehicle_${planVehicleKey}`,
      name: <TranslatedText translationKey="Vehicle" />,
      component: shouldBlockModuleAccess(planVehicleKey) ? (
        <BlockAccessPage />
      ) : (
        <UpVehicleTable selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerUpstreamVehicle)
    }
  ].filter((item) => !item.hidden);

  return <Tabs array={UPSTab} />;
};

export default Upstream;
